<template>
  <div class="note-box">
    <div class="courseware-note-list-head">
      <div class="user">
        <v-img
          class="img"
          :attachment-id="info.profilePictureAttmId"
          :default-img="require('@/assets/img/kctp.png')"
        />
        <span>{{ info.createByName }}</span>
      </div>
      <!-- <PointTime :currentTime="info.markTime" @changeTime="changeTime" /> -->
    </div>
    <div class="courseware-note-list-desc" v-html="info.content"></div>
    <div class="courseware-note-list-footer">
      <span>{{ dayjs(info.createTime).format("YYYY-MM-DD") }}</span>
      <p v-if="studentInfo.id === info.userId">
        <span @click="$emit('edit', info)"
          ><img src="@/assets/img/editicon.png" /> 编辑</span
        >
        <span v-if="!info.isPublic" @click="$emit('open', info)"
          ><img src="@/assets/img/gkicon.png" />公开笔记</span
        >
        <span v-if="info.isPublic" @click="$emit('open', info)"
          ><img src="@/assets/img/yinchang.png" />隐藏笔记</span
        >
        <a-popconfirm
          title="确定删除笔记吗？"
          ok-text="是"
          cancel-text="否"
          @confirm="$emit('del', info)"
        >
          <span><img src="@/assets/img/delicon.png" /> 删除</span>
        </a-popconfirm>
      </p>
    </div>
  </div>
</template>

<script>
import PointTime from "./pointTime.vue";
import VImg from "@/components/VImg";
import dayjs from "dayjs";
import { mapGetters } from "vuex";

export default {
  props: ["info"],
  components: {
    PointTime,
    VImg,
  },
  data() {
    return {
      courseInfoTab: 1,
      courseDetail: {},
      courseList: [],
      dayjs,
      studentInfo: {},
    };
  },
  computed: {
    ...mapGetters(["userInfo"]),
  },
  mounted() {
    this.studentInfo = this.userInfo;
  },
  methods: {
    changeTime() {
      this.$emit("changeTime", this.info.markTime);
    },
  },
};
</script>

<style scoped lang="scss">
.note-box {
  padding: 24px 0;
  border-bottom: 1px solid #ebedf0;
  .courseware-note-list-head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
    .user {
      display: flex;
      align-items: center;
      .img {
        display: block;
        width: 40px;
        height: 40px;
        border-radius: 50%;
        margin-right: 16px;
      }
      > span {
        font-weight: 400;
        font-size: 14px;
        color: #323233;
        line-height: 20px;
      }
    }
  }
  .courseware-note-list-desc {
    margin-bottom: 24px;
    font-weight: 400;
    font-size: 14px;
    color: #323233;
    line-height: 20px;
  }
  .courseware-note-list-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #8c8c8c;
    > span {
      font-size: 12px;
      color: #8c8c8c;
      line-height: 16px;
    }
    > p {
      display: flex;
      align-items: center;
      > span {
        display: flex;
        align-items: center;
        font-size: 12px;
        color: #8c8c8c;
        line-height: 16px;
        margin-right: 16px;
        cursor: pointer;
        > img {
          margin-right: 4px;
        }
      }
    }
  }
}
</style>
